module.exports = __webpack_public_path__ + "img/wireframe-compare.79eab849.jpg";